"use client";

import { useEffect } from "react";

export default function GlobalUrlParamsHandler() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const soId = urlParams.get("soId");
      const location = urlParams.get("loc");
      const type = urlParams.get("type");
      if (soId !== null && soId !== "" && location !== null && location !== "" && type !== null && type !== "") {
        let lsSo = localStorage.getItem("so");
        const so = { id: soId, location: location, type: type };
        localStorage.setItem("isSo", "true");
        localStorage.setItem("so", JSON.stringify(so));

        // Create search parameters
        const searchParams = new URLSearchParams({
          currency: "AED",
          measurement: "imperial",
          onlyAvailable: "true",
          type: "project",
        });

        window.history.replaceState(null, "", window.location.pathname);
        // window.location.href = window.location.origin + window.location.pathname + `search/?${searchParams.toString()}`;
        window.location.href = window.location.origin + window.location.pathname;
      }
    }
  }, []);

  return null;
}
